'use client';

import { Button, Empty, Pagination, Select, Spin, message } from 'antd';
import 'ckeditor5/ckeditor5.css';
import { PrimaryServiceCardComp, ServiceFilterComp } from 'components';
import { GlobalContext } from 'context';
import { PATH } from 'data';
import { API } from 'data/index';
import { useContext, useEffect, useRef, useState } from 'react';
import { BiSortAlt2 } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa6';
import { nextBrowser } from 'scripts';
import { RestAPI } from 'scripts/index';
import { CategoryType, PLPType, ServiceType } from 'types';
import { PaginationType } from 'types/index';
import styles from './servicesList.module.scss';
import { __ServicesListPropsType } from './servicesList.type';
function ServicesListComp({
  services,
  categories,
  initialFilter,
  brands,
  dataCount,
  pageSize,
  category,
  initialLocation,
  description
}: __ServicesListPropsType) {
  const [isOpen, setIsOpen] = useState(false);
  const [filterValues, setFilterValues] = useState(typeof initialFilter.brand !== 'string' ? {
    ...initialFilter,
    location: initialLocation
  } : {
    ...initialFilter,
    brand: [initialFilter.brand],
    location: initialLocation
  });
  const initialBrand = useRef(typeof initialFilter.brand !== 'string' ? initialFilter.brand : [initialFilter.brand]);
  const [servicesPage, setServicesPage] = useState(dataCount);
  const [serviceList, setServiceList] = useState<ServiceType[] | null>(services);
  const [categoryData, setCategoryData] = useState(category);
  const [messageApi, contextHolder] = message.useMessage();
  const {
    langText,
    location
  } = useContext(GlobalContext);
  const [seoDescription, setSeoDescription] = useState(description);
  const lang = langText.serviceList;
  const sortList: {
    id: number;
    title: string;
    slug: string;
  }[] = [{
    id: 5,
    title: lang.mostPriority,
    slug: 'most_priority'
  }, {
    id: 1,
    title: lang.newest,
    slug: 'newest'
  }, {
    id: 2,
    title: lang.oldest,
    slug: 'oldest'
  }, {
    id: 3,
    title: lang.most_visited,
    slug: 'most_order'
  }, {
    id: 4,
    title: lang.most_popular,
    slug: 'most_favorite'
  }];
  const sortHandler = (slug: string) => {
    setFilterValues({
      ...filterValues,
      order: slug,
      page: '1'
    });
  };
  const buyHandler = (service: ServiceType) => {
    setServiceList(list => {
      if (list) {
        const newList = [...list];
        const index = list.findIndex(i => i.id === service.id);
        if (index > -1) {
          newList[index].is_ordered = 1;
        }
        return newList;
      }
      return [];
    });
  };
  useEffect(() => {
    if (filterValues.category) {
      if (filterValues.category !== categoryData?.slug) {
        if (filterValues.category === category?.slug) {
          setCategoryData(category);
          setSeoDescription(description);
        } else {
          setCategoryData(undefined);
          setSeoDescription(undefined);
          RestAPI.get<CategoryType>(API.categories.detail(filterValues.category)).then(res => setCategoryData(res.data));
          RestAPI.get<PaginationType<PLPType>>(API.services.description(filterValues.category, filterValues.location.slug)).then(res => setSeoDescription(res.data.data?.[0]?.content));
        }
      }
    } else {
      setCategoryData(undefined);
      setSeoDescription(undefined);
    }
  }, [filterValues.category]);
  useEffect(() => {
    const params: {
      [key: string]: string | string[];
    } = {};
    // if (filterValues.serviceType) params.serviceType = filterValues.serviceType;
    if (filterValues.category) params.category = filterValues.category;
    if (filterValues.starGTE) params.starGTE = filterValues.starGTE.toString();
    if (filterValues.starLTR) params.starLTR = filterValues.starLTR.toString();
    if (filterValues.order) params.order = filterValues.order;
    if (filterValues.search) params.search = filterValues.search;
    if (filterValues.page) params.page = filterValues.page;
    const cloneParams = {
      ...params
    };
    delete cloneParams.category;
    const path = new URL(nextBrowser?.window?.location.origin + (filterValues.category ? PATH(langText.lang).services.category(location.slug, filterValues.category ?? '', cloneParams) : PATH(langText.lang).services.index(location.slug, cloneParams)));
    if (filterValues.location) params.location = filterValues.location.slug;
    filterValues.brand?.map(brand => path.searchParams.append('brand', brand));
    window.history.replaceState(null, '', path);
    const descriptionMetaTag: HTMLLinkElement | null = document.querySelector('link[rel="canonical"]');
    if (descriptionMetaTag) descriptionMetaTag.href = path.href;
    if (filterValues.brand?.sort().join() === initialBrand.current?.sort().join() && filterValues.category === initialFilter.category && filterValues.order === initialFilter.order && filterValues.search === initialFilter.search && filterValues.starGTE === initialFilter.starGTE && filterValues.starLTR === initialFilter.starLTR && (filterValues.page === '1' && initialFilter.page === undefined || filterValues.page === initialFilter.page) && filterValues.location?.slug === initialLocation?.slug) {
      setServiceList(services);
      setServicesPage(dataCount);
    } else {
      const newParams: {
        [key: string]: string | string[];
      } = {};
      if (params.category) newParams.category_and_descendants = params.category;
      if (params.starGTE) newParams.star_gte = params.starGTE.toString();
      if (params.starLTR) newParams.star_lte = params.starLTR.toString();
      if (params.order) newParams.order = params.order;
      if (params.search) newParams.title__icontains = params.search;
      if (params.page) newParams.page = params.page;
      if (filterValues.location) newParams.location_and_descendants_slug = filterValues.location.slug;
      if (filterValues.brand) newParams.brand__slug__in = filterValues.brand;
      // if (params.serviceType) newParams.serviceType = params.serviceType;

      setServiceList(null);
      RestAPI.get<PaginationType<ServiceType>>(API.services.index, {
        ...newParams,
        lang: langText.lang,
        page_size: pageSize,
        brand__is_active: true,
        is_active: true
      }).then(res => {
        setServiceList(res.data.data);
        setServicesPage(res.data.count);
      }).catch(() => {
        messageApi.open({
          type: 'error',
          content: lang.errorMessage
        });
      });
    }
  }, [filterValues]);
  return <div className={`${styles['services-list-layout']} main-content`} data-sentry-component="ServicesListComp" data-sentry-source-file="servicesList.index.tsx">
            {contextHolder}
            <div className={`${styles['filter-card']} d-flex`}>
                <div className={`${styles['filter']} d-pre-lg-none`}>
                    <ServiceFilterComp isOpen={isOpen} setIsOpen={setIsOpen} category={categories} brands={brands} setFilterValues={e => setFilterValues({
          ...e,
          location: e.location ?? location
        })} filterValues={filterValues} data-sentry-element="ServiceFilterComp" data-sentry-source-file="servicesList.index.tsx" />
                </div>
                <div className={`${styles['card-list']} d-flex flex-column`}>
                    <h3 className="t-800 t-h3 t-dark mb-3">{categoryData?.title ?? lang.servicesTile}</h3>
                    <div className={`${styles['btn-box']} d-none d-pre-lg-flex justify-content-between align-items-center gap-16 mb-2`}>
                        <Button onClick={() => setIsOpen(true)} type="primary" className="d-none-i d-pre-lg-flex-i gap-8 w-100 center-content-x" data-sentry-element="Button" data-sentry-source-file="servicesList.index.tsx">
                            <FaFilter size={15} data-sentry-element="FaFilter" data-sentry-source-file="servicesList.index.tsx" /> {lang.filters}
                        </Button>
                        <Select placeholder={lang.ordering} className="d-none-i d-pre-lg-flex-i w-100 text-center" suffixIcon={<BiSortAlt2 size={20} />} options={[{
            value: 'most_priority',
            label: lang.mostPriority
          }, {
            value: 'newest',
            label: lang.newest
          }, {
            value: 'oldest',
            label: lang.oldest
          }, {
            value: 'most_order',
            label: lang.most_visited
          }, {
            value: 'most_favorite',
            label: lang.most_popular
          }]} onChange={sortHandler} value={filterValues?.order ?? null} data-sentry-element="Select" data-sentry-source-file="servicesList.index.tsx" />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2 d-pre-lg-none">
                        <span className="d-flex align-items-center">
                            <span className="t-500 t-p1 t-dark1 d-block">{lang.ordering} :</span>
                            {sortList.map(item => <span onClick={() => sortHandler(item.slug)} key={item.id} className={`${item.slug === filterValues?.order ? styles['active'] : ''} t-p1 t-400 t-dark3`}>
                                    {item.title}
                                </span>)}
                        </span>
                        {serviceList !== null && <span className={`d-block t-p1 t-400 t-dark3`}>
                                {dataCount} {lang.result}
                            </span>}
                    </div>
                    <div>
                        {serviceList?.length === 0 ? <Empty className="mt-8" description={lang.empty} /> : serviceList ? serviceList.map(service => <PrimaryServiceCardComp key={service.id} data={service} onBuy={() => buyHandler(service)} params={filterValues} />) : <div className={`${styles['spin']} w-100 pv-6 center-content`}>
                                <Spin />
                            </div>}
                    </div>
                    {serviceList && servicesPage > pageSize && <div className={`${styles['pagination-layout']} d-flex center-content mt-3 mb-10`}>
                            <div className={`${styles['pagination']} d-flex center-content mt-3`}>
                                <Pagination size="small" current={filterValues.page ? Number(filterValues.page) : 1} pageSize={pageSize} total={servicesPage} showSizeChanger={false} hideOnSinglePage onChange={e => setFilterValues({
              ...filterValues,
              page: e.toString()
            })} />
                            </div>
                        </div>}
                    {seoDescription?.length && <div className={`${styles['about-slider-layout']}`}>
                            <div className={`${styles['about']} mt-3`}>
                                <h4 className="t-700 t-h4 t-dark1 mb-2">
                                    {lang.about} <span className="t-primary">{categoryData?.title}</span>
                                </h4>
                                <div className="t-p1 t-400 t-dark2 ck-content" dangerouslySetInnerHTML={{
              __html: seoDescription ?? ''
            }} />
                            </div>
                        </div>}
                </div>
            </div>
        </div>;
}
export default ServicesListComp;